var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLpLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.41421 6L6.70711 1.70711C7.09763 1.31658 7.09763 0.683418 6.70711 0.292893C6.31658 -0.0976309 5.68342 -0.0976309 5.29289 0.292893L0.292893 5.29289C-0.0976309 5.68342 -0.0976309 6.31658 0.292893 6.70711L5.29289 11.7071C5.68342 12.0976 6.31658 12.0976 6.70711 11.7071C7.09763 11.3166 7.09763 10.6834 6.70711 10.2929L2.41421 6Z",
    fill: "#44444F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpLeft);
export default __webpack_public_path__ + "static/media/lpLeft.c6b11c8d54adb8b719351acae33ed510.svg";
export { ForwardRef as ReactComponent };